<template>
    <div class="breadcrumb">
        <div class="breadcrumb-link">
            <NuxtLink to="/" class="breadcrumb-text">Главная</NuxtLink>
                <img src="/images/documents/arrow-right.svg" alt="Иконка стрелки вправо" class="arrow-icon" />
        </div>
    <p class="breadcrumb-text">{{ page }}</p>
    </div>
</template>

<script setup>
const props = defineProps({
    page: {
        type: String,
        required: true,
    },
});
</script>

<style scoped>
.breadcrumb {
    display: flex;
    gap: 8px;
    align-items: center;
    margin: 0;
}

.breadcrumb-link {
    display: flex;
    gap: 8px;
}

.breadcrumb-text {
    font-weight: 400;
    font-style: Regular;
    font-size: 14px;
    leading-trim: NONE;
    line-height: 20px;
    letter-spacing: 0%;
    text-align: center;
    margin: 0;
    color: #2B2B2B;
    text-decoration: none;
}

@media screen and (max-width: 1279px) {
    .breadcrumb {
        flex-direction: column;
        gap: 16px;
        align-items: flex-start;
    }
}
</style>